module.exports = '2017-05-16';



// WEBPACK FOOTER //
// ./version.js